import { createSlice } from '@reduxjs/toolkit';
// utils
import axiosIntanceAccessZalo from '../../helper/axiosIntanceAccessZalo';
import apiZalo from '../../api/zalo';

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  error: "false",
  info:{},
};
//
// name : teen store quan li
const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    // ACCESS ZALO
    statusAccessZaloSuccess(state, action) {
      const participants = action.payload;
      state.zalo = participants;
    },
    // ACCESS ZALO
    statusAccessFacebookSuccess(state, action) {
      const participants = action.payload;
      state.facebook = participants;
    },
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------


export function getAccessZalo(param) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await apiZalo.accessToken(param) ;
      dispatch(slice.actions.statusAccessZaloSuccess(response.data));
    } catch (error) {
      console.log(error)
      dispatch(slice.actions.hasError(error));
    }
  };
}


